import { useState, useEffect } from 'react';

export function usePwaInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isStandalone, setIsStandalone] = useState(() => {
    if (typeof window === 'undefined') return false;
    const mq = typeof window.matchMedia === 'function' ? window.matchMedia('(display-mode: standalone)') : null;
    return (
      (mq && mq.matches) ||
      window.navigator?.standalone === true ||
      (typeof document !== 'undefined' && document.referrer?.includes('android-app://'))
    );
  });
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    // Check if running in standalone mode
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleModeChange = (e) => setIsStandalone(e.matches);
    try {
      mediaQuery.addEventListener('change', handleModeChange);
    } catch {
      mediaQuery.addListener(handleModeChange);
    }

    // Capture browser install prompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setCanInstall(false);
      setIsStandalone(true);
      console.log('[PWA] Physicians Health Portal installed successfully');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      try {
        mediaQuery.removeEventListener('change', handleModeChange);
      } catch {
        mediaQuery.removeListener(handleModeChange);
      }
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  async function triggerInstall() {
    if (!deferredPrompt) {
      return false;
    }
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    if (outcome === 'accepted') {
      setCanInstall(false);
      return true;
    }
    return false;
  }

  return {
    isStandalone,
    canInstall,
    triggerInstall,
    hasNativePrompt: !!deferredPrompt
  };
}

